module.exports = __webpack_public_path__ + "img/home-avatar.f6d0772d.png";